import React, { useState } from "react";
import {
  Message,
  TextArea,
  InputField,
  AddPageShell,
  AddSection,
} from "../components/Component";
import { codeOk, errorMessage } from "../../lib/index";
import { useClimateContext } from "../../context/ClimateContext";
import { getOneClimate } from "../../lib/sysNavigation/SysNavigation";
import { TiWeatherPartlySunny } from "react-icons/ti";

const Edit = () => {
  const { updateClimateState, updateClimate } = useClimateContext();
  const climate = getOneClimate();

  const [error, setError] = useState(false);
  const [status, setStatus] = useState(0);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const climate_id = climate.climate_id;

  const [name, setName] = useState(climate.name);
  const [description, setDescription] = useState(climate.description);

  const climateRoutes = "/climate";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
  };

  const responses = (isError: any, statusCode: any, msg: any) => {
    setError(isError);
    setStatus(statusCode);
    setErrorMessage(msg);
  };

  const updateOneClimateHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const data = { name, description };
    const response = await updateClimate(climate_id, data);

    if (response) {
      if (response.data.status === codeOk) {
        updateClimateState({ climate_id, ...data });
        cleanFields();
        return responses(false, response.data.status, response.data.message);
      } else {
        setLoading(false);
        return responses(true, response.data.status, response.data.message);
      }
    } else {
      setLoading(false);
      return responses(true, 400, errorMessage);
    }
  };

  return (
    <AddPageShell
      backRoute={climateRoutes}
      eyebrow="Catalog • Climates"
      title="Edit Climate"
      subtitle="Updated the climate label and description."
      icon={<TiWeatherPartlySunny className="h-5 w-5" />}
      size="md"
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOneClimateHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage("");
      }}
      message={
        <Message
          props={{
            error,
            success,
            message,
            loading,
            status,
            onClick: () => {
              setError(false);
              setSuccess(false);
              setErrorMessage("");
            },
          }}
        />
      }
    >
      <AddSection
        title="Climate Details"
        hint="Briefly describe the typical weather and travel comfort."
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <InputField
            props={{
              id: "title",
              title: "Name",
              type: "text",
              required: true,
              value: name ? name : "",
              onChange: (e: any) => {
                setName(e.target.value);
                setError(false);
                setSuccess(false);
              },
            }}
          />
          <div className="hidden items-center gap-2 rounded-lg bg-gray-50 px-3 py-2 text-[11px] text-gray-600 ring-1 ring-gray-200 md:flex">
            Use a short, recognisable label (e.g. "Tropical", "Arid").
          </div>
          <div className="md:col-span-2">
            <TextArea
              props={{
                id: "description",
                title: "Description",
                type: "text",
                required: true,
                value: description ? description : "",
                onChange: (e: any) => {
                  setDescription(e.target.value);
                  setError(false);
                  setSuccess(false);
                },
              }}
            />
          </div>
        </div>
      </AddSection>
    </AddPageShell>
  );
};

export default Edit;
